import React, { useState } from "react";
import { Avatar, Box, Typography, CircularProgress, IconButton } from "@mui/material";
import { useDropzone } from "react-dropzone";
import profile from "../../assets/images/user.png";
import fileUpload from "../../assets/images/fileUpload.png"
import { ReactComponent as Upload } from "../../assets/AccountingModule/upload.svg";
import { DeleteOutline, LocalSeeOutlined } from "@mui/icons-material";
import styles from "./style";

const DragAndDropInput = ({
  handleUrl,
  isFrom,
  profileImg,
  title,
  disabled = false,
  uploading = false,
  onDelete,
  replaceEditIconWithDelete = false,
}) => {
  const [file, setFile] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const onDrop = (acceptedFiles) => {
    if (disabled || uploading) return;
    setFile(acceptedFiles[0]);
    if (isFrom !== "edit") {
      setImageUrl(URL.createObjectURL(acceptedFiles[0]));
    }
    handleUrl(acceptedFiles[0]);
  };
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, disabled: disabled || uploading });
  const previewImage =
    isFrom === "edit"
      ? (profileImg || profile)
      : (imageUrl || profileImg || (title === "Import Attendance" || title === "Import Tax Table" ? fileUpload : profile));
  const shouldReplaceEditIconWithDelete =
    replaceEditIconWithDelete && typeof onDelete === "function" && !!profileImg;

  return (
    <Box
      {...getRootProps()}
      sx={{
        width: isFrom === "edit" ? { xs: "auto", sm: "auto", md: "auto", } : "100%",
        height: isFrom === "edit" ? "100%" : "30%",
        border: isFrom === "edit" ? "none" : `1px dashed ${disabled ? "#d1d5db" : "#ccc"}`,
        borderRadius: isFrom === "edit" ? "100%" : "5px",
        py: isFrom !== "edit" && 5,
        px: 1,
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
        cursor: disabled || uploading ? "not-allowed" : "pointer",
        bgcolor: disabled ? "#f5f5f5" : isDragActive ? "#eee" : "transparent",
        borderColor: disabled ? "#d1d5db" : undefined,
      }}
    >
      <input {...getInputProps()} />
      {isFrom === "edit" ?
        <Box sx={styles.imageContainer}>
          <Avatar src={previewImage} alt={!file ? "select" : file.name} sx={{ width: "4em", height: "4em" }} />
          {uploading ? (
            <Box sx={styles.loaderOverlay}>
              <CircularProgress size={22} thickness={5} />
            </Box>
          ) : shouldReplaceEditIconWithDelete ? (
            <IconButton
              type="button"
              size="small"
              sx={styles.editActionButton}
              onClick={(event) => {
                event.stopPropagation();
                setFile(null);
                setImageUrl("");
                onDelete();
              }}
            >
              <DeleteOutline fontSize="small" />
            </IconButton>
          ) : (
            <>
              <LocalSeeOutlined sx={styles.cameraIcon} />
              {typeof onDelete === "function" && profileImg ? (
                <IconButton
                  type="button"
                  size="small"
                  sx={styles.deleteIcon}
                  onClick={(event) => {
                    event.stopPropagation();
                    setFile(null);
                    setImageUrl("");
                    onDelete();
                  }}
                >
                  <DeleteOutline fontSize="small" />
                </IconButton>
              ) : null}
            </>
          )}
        </Box> :
        <>
          <Avatar src={previewImage} alt={!file ? "select" : file.name} sx={{ width: "3em", height: "3em", objectFit: "contain" }} />
        </>
      }
      {isFrom !== "edit" &&
        <Box sx={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center" }}>
          <Box sx={styles.chooseIconSection}>
            {/* <Box sx={{mr: 1}}><Upload /></Box>         */}
            <Typography sx={styles.choose}>Choose File
            </Typography></Box>
          <Typography sx={styles.dragText}>
            {isDragActive ? "Drop the file here" : "Or drag and drop file here."}
          </Typography>
        </Box>}
    </Box>
  );
};

export default DragAndDropInput;
